import type { NotificationMessageData } from '@lighthouse/shared'
import { useMessage } from '@lighthouse/shared'
import React, { useEffect } from 'react'

interface ApplicationMessageProps {
    appId: string
}

export const ApplicationMessage: React.FC<ApplicationMessageProps> = ({ appId }) => {
    const { lastMessage, getWebSocket } = useMessage<NotificationMessageData>(appId, true, 'dummyUniqueUserId')

    useEffect(() => {
        return () => {
            getWebSocket()?.close()
        }
    }, [getWebSocket])

    return <></>
}
